export const LOAD_INIT = 'LOAD_INIT';
export const LOAD_REQUERY = 'LOAD_REQUERY'
export const LOAD_SUCCESS = 'LOAD_SUCCESS';
export const LOAD_ERROR = 'LOAD_ERROR';
export const RELEASE_TABLE_DATA = 'RELEASE_TABLE_DATA';
export const SET_PAGE = 'SET_PAGE';
export const PAGE_COUNT_INIT = 'PAGE_COUNT_INIT';
export const GET_PAGE_COUNT = 'GET_PAGE_COUNT';